import {UserDao} from '../../dao';
import {AuthModel, ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'GET_USER_TOKEN';

export async function getUserToken(userCredentials: Record<string, string>) {
    try {
        const result = await UserDao.getUserToken(userCredentials.username, userCredentials.password);

        const parsedResult = AuthModel.parseAuth(result);

        return parsedResult;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération d\'un token .',
            error: error
        });
    }
}
